import { useState } from 'react';
import PropTypes from 'prop-types';
import { Card } from '@mui/material';
import CustomTable from '../Table';

const MemberListResults = ({
  members = [],
  onClickRow = () => {},
  onEdit = () => {},
  onDelete = () => {},
  handleOpenModal,
  handleNavigate,
  filterItem,
  ...rest
}) => {
  const [page, setPage] = useState(0);

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  return (
    <Card {...rest}>
      <CustomTable
        data={members}
        dataKeysSequence={[
          'full_name',
          'plan',
          'membership_start_date',
          'father_name',
          'batch',
          'trainer',
          'actions'
        ]}
        headers={[
          'Name',
          'Membership Plan',
          'Joining Date',
          'Father Name',
          'Batch',
          'Trainer',
          'Actions'
        ]}
        handlePageChange={handlePageChange}
        handleOpenModal={handleOpenModal}
        handleNavigate={handleNavigate}
        page={page}
        onDelete={onDelete}
        onEdit={onEdit}
      />
    </Card>
  );
};

MemberListResults.propTypes = {
  members: PropTypes.array.isRequired
};

export default MemberListResults;
